import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core/'

class FormDeleteButton extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  }

  render() {
    const {
      children,
      ...buttonProps
    } = this.props

    const props = {
      ...buttonProps,
      color: 'secondary',
      variant: 'text',
    }

    return (
      <Button {...props}>
        { children }
      </Button>
    )
  }
}

export default FormDeleteButton
